angular
	.module('utils')
	.factory('tgResource', function ($resource, $location, tgConfig, tgUpload, $uibModal, $q) {
		function buildResource(resourceName, resourceLabel, host) {
			var host = host || tgConfig.api
			host = host.replace(/https?/, $location.protocol())
			var MyResource = $resource(host + '/' + resourceName + '/:id', null, {
				update: { method: 'PUT' },
				count: { method: 'GET', params: { id: 'count' }, isArray: false }, //counts query results for pagination purposes
			})

			MyResource.saveWithFileUpload = function (params, data, successCallback, errorCallback) {
				if (params && params.id) {
					return tgUpload(
						host + '/' + resourceName + '/' + params.id,
						'PUT',
						'avatarUrl',
						data,
						successCallback,
						errorCallback
					)
				} else {
					return tgUpload(
						host + '/' + resourceName + '/',
						'POST',
						'avatarUrl',
						data,
						successCallback,
						errorCallback
					)
				}
			}

			MyResource.saveWithFileUploadToFields = function (
				params,
				data,
				fields,
				successCallback,
				errorCallback
			) {
				if (params && params.id) {
					return tgUpload(
						host + '/' + resourceName + '/' + params.id,
						'PUT',
						fields,
						data,
						successCallback,
						errorCallback
					)
				} else {
					return tgUpload(
						host + '/' + resourceName + '/',
						'POST',
						fields,
						data,
						successCallback,
						errorCallback
					)
				}
			}

			MyResource.safeDelete = function (resource, callback) {
				var modalInstance = $uibModal.open({
					animation: true,
					template:
						'<div class="modal-header">' +
						'<h3 class="modal-title text-danger">Delete ' +
						_.capitalize(resourceLabel) +
						' - ' +
						resource.name.pt +
						'</h3>' +
						'</div>' +
						'<div class="modal-body text-danger">' +
						"<h4> {{ 'Are you sure?' | translate }} </h4>" +
						"<p> {{ 'If so, type in the " +
						resource.name.pt +
						" name you want to exclude:' | translate }} </p>" +
						'<input class="form-control" type="text" placeholder="{{ \'Check the ' +
						resource.name.pt +
						' name here\' | translate }}" ng-model="check"/>' +
						'<div ng-if="check"><br>' +
						'<div ng-if="check == resource.name.pt" class="alert alert-warning animated fadeIn"> <span class="glyphicon glyphicon-info-sign"></span> {{ \'Are you sure you want to delete \' | translate }} <strong>{{check}}</strong> ?</div>' +
						'<div ng-if="check != resource.name.pt" class="alert alert-danger" ng-class="{ \'animated\': emphasizeError, \'shake\': emphasizeError}"> <span class="glyphicon glyphicon-alert"></span> {{ \'Type in the complete ' +
						resourceLabel +
						" name you want to exclude above.' | translate }} </div>" +
						'</div>' +
						'</div>' +
						'<div class="modal-footer">' +
						'<button class="btn btn-danger" ng-click="ok()" ng-disabled="!check"> {{ \'Ok\' | translate }}</button>' +
						'<button class="btn btn-default" ng-click="cancel()"> {{ \'Cancel\' | translate }} </button>' +
						'</div>',
					resolve: {
						resource: function () {
							if (resource && resource._id) {
								return resource
							} else {
								return $q.reject('no resource')
							}
						},
					},
					controller: [
						'$scope',
						'$uibModalInstance',
						'resource',
						'$timeout',
						function ($scope, $uibModalInstance, resource, $timeout) {
							$scope.resource = resource
							$scope.check = null
							$scope.ok = function () {
								if ($scope.check === $scope.resource.name.pt) {
									$uibModalInstance.close($scope.resource)
								} else {
									$scope.emphasizeError = true
									$timeout(function () {
										$scope.emphasizeError = false
									}, 1000)
								}
							}

							$scope.cancel = function () {
								$uibModalInstance.dismiss('cancel')
							}
						},
					],
				})

				modalInstance.result.then(
					function (resource) {
						callback(resource)
					},
					function () {
						//console.log('Modal dismissed at: ' + new Date());
						angular.noop()
					}
				)
			}

			MyResource.addRoute = function (routeName, routeAddress, routeParams, routeOptions) {
				if (!routeOptions) {
					routeOptions = {
						update: {
							method: 'PUT',
						},
					}
				}

				//
				MyResource[routeName] = $resource(host + routeAddress, routeParams, routeOptions)
			}

			return MyResource
		}

		return buildResource
	})
